"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const git_version_json_1 = __importDefault(require("./git-version.json"));
class Info {
    get version() {
        return git_version_json_1.default.tag;
    }
    get hash() {
        return git_version_json_1.default.hash;
    }
    get date() {
        return git_version_json_1.default.date;
    }
}
exports.default = new Info();
//# sourceMappingURL=Info.js.map